import React from 'react';

const SvgGy = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="GY_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="GY_svg__b" fill="#fff">
        <use xlinkHref="#GY_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#GY_svg__a" />
      <path fill="#08C55F" mask="url(#GY_svg__b)" d="M0 0h28v20H0z" />
      <path
        d="M-.667 19.333h.559l27.441-9.147v-.372L-.108.667h-.559v18.666z"
        stroke="#FFF"
        strokeWidth={1.333}
        fill="#FFD831"
        mask="url(#GY_svg__b)"
      />
      <path
        d="M-.667 19.333h.469L14.112 10-.197.667h-.469v18.666z"
        stroke="#262626"
        strokeWidth={1.333}
        fill="#E92034"
        mask="url(#GY_svg__b)"
      />
    </g>
  </svg>
);

export default SvgGy;
